<template>
  <!-- 章节练习查看解析 -->
  <div class="uni-startPractice">
    <div class="leftBox" id="leftBox">
      <i class="iconfont iconfanhui" @click="$router.go(-1)"></i>
      <div class="grade">
          {{ otherInfoDTO.score }}
          <span class="f20">分</span>
        </div>
      <div class="title" v-if="topicTypeZn === 'zhi_neng_lian_xi'">
         <span v-for="(item, index) in otherInfoDTO.title" :key="index"
            >{{ item }}<em v-if="otherInfoDTO.title.length - 1 !== index"></em
          ></span>
      </div>
      <div v-else>
        <!--<div class="grade" v-if="$route.query.topicType !== 'cuo_ti_ku'">
          {{ otherInfoDTO.score }}
          <span class="f20">分</span>
        </div>-->
        <div class="title">
          <span v-for="(item, index) in otherInfoDTO.title" :key="index"
            >{{ item }}<em v-if="otherInfoDTO.title.length - 1 !== index"></em
          ></span>
        </div>
      </div>

      <div
        class="topicDivButton"
        :class="fontClass"
        v-for="(itemTo, index) in topicLists"
        :key="index"
      >
        <div
          class="topicDiv"
          :id="itemTo.question_style != 6 && `id_${itemTo.sort}`"
        >
          <!-- 1 单选题 -->
          <ChoiceOne
            v-if="itemTo.question_style === 1"
            :datas="itemTo"
            :isDisabled="isDisabled"
            @next="saveAnswer(itemTo)"
          />
          <!-- 2 判断题 -->
          <Judge
            v-if="itemTo.question_style === 2"
            :datas="itemTo"
            :isDisabled="isDisabled"
            @next="saveAnswer(itemTo)"
          />
          <!-- 3 多选题 -->
          <ChoiceMultiple
            v-if="itemTo.question_style === 3"
            :datas="itemTo"
            :isDisabled="isDisabled"
            @next="saveAnswer(itemTo)"
          />
          <!-- 4 填空题 -->
          <FillBlank
            v-if="itemTo.question_style === 4"
            :datas="itemTo"
            :isDisabled="isDisabled"
            @next="saveAnswer(itemTo)"
          />
          <!-- 5简答题 -->
          <Subjective
            v-if="itemTo.question_style === 5"
            :datas="itemTo"
            :isDisabled="isDisabled"
            @next="saveAnswer(itemTo)"
          />
          <!-- 解析 -->
          <QuestionAnalysis
            v-if="itemTo.question_style !== 6"
            :analysisDatas="itemTo"
            :makeType="otherInfoDTO.make_type"
            :course_id="otherInfoDTO.course_id"
            @noteChange="getDatas"
          />

          <!-- 6 一题多问 -->
          <div v-if="itemTo.question_style === 6">
            <div
              class="questionAskTitle"
              id="questionAskTitle"
              v-html="itemTo.content"
            ></div>
            <!-- 音频 -->
            <div class="audioDiv" v-if="itemTo.audio_url">
              <audio
                class="sourceAudio"
                controls="controls"
                v-for="(itemAudio, indexAudio) in itemTo.audio_url.split(',')"
                :key="indexAudio"
              >
                <source :src="itemAudio" type="audio/ogg" />
                Your browser does not support the audio element.
              </audio>
            </div>
            <!-- 小题 -->
            <div
              v-for="(item, index) in itemTo.child"
              :key="index"
              :id="`id_${item.sort}`"
            >
              <!--      1 单选题-->
              <ChoiceOne
                v-if="item.question_style === 1"
                :datas="item"
                :isDisabled="isDisabled"
                @next="saveAnswer(item)"
              />
              <!--     4 填空题-->
              <FillBlank
                v-if="item.question_style === 4"
                :datas="item"
                :isDisabled="isDisabled"
                @next="saveAnswer(item)"
              />
              <!--      2判断题-->
              <Judge
                v-if="item.question_style === 2"
                :datas="item"
                :isDisabled="isDisabled"
                @next="saveAnswer(item)"
              />
              <!--      3多选题-->
              <ChoiceMultiple
                v-if="item.question_style === 3"
                :datas="item"
                :isDisabled="isDisabled"
                @next="saveAnswer(item)"
              />
              <!-- 5简答题 -->
              <Subjective
                v-if="itemTo.question_style === 5"
                :datas="itemTo"
                :isDisabled="isDisabled"
                @next="saveAnswer(itemTo)"
              />
              <!-- 解析 -->
              <QuestionAnalysis
                :analysisDatas="item"
                :course_id="otherInfoDTO.course_id"
                :makeType="otherInfoDTO.make_type"
                @noteChange="getDatas"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mat20">
      <AnswerSheet
        :isAnalysis="true"
        :datas="topicCard"
        :total="total"
        @change="jumpTo"
        @submit="submit"
      />
    </div>
  </div>
</template>

<script>
import AnswerSheet from "@/components/answerSheet";
import ChoiceOne from "@/views/business/questionType/questionChoiceOne";
import FillBlank from "@/views/business/questionType/questionFillBlank";
import Judge from "@/views/business/questionType/questionJudge";
import ChoiceMultiple from "@/views/business/questionType/questionChoiceMultiple";
import Subjective from "@/views/business/questionType/questionSubjective";
import QuestionAnalysis from "@/views/business/questionType/questionAnalysis";
import { getAnalysis } from "@/api/basic";
import { mapState } from "vuex";

export default {
  name: "uni-startPractice",
  computed: {
    ...mapState("common", {
      fontClass: (state) => state.fontClass,
    }),
  },
  components: {
    AnswerSheet, //工具栏
    QuestionAnalysis, //解析
    ChoiceOne, //单选
    FillBlank, //填空
    Judge, //判断
    ChoiceMultiple, //多选
    Subjective, //简答
  },
  data() {
    return {
      isDisabled: true,
      // 路由参数
      make_id: this.$route.query.make_id, //课程id
      otherInfoDTO: [],
      topicCard: [],
      topicLists: [],
      total: 0,
      // 分数弹框
      scoreDialog: {
        title: "",
        score: 0,
        icon: "",
        isScoreVisible: false,
        showCancelBtn: true,
      },
      // 当前题目
      currentQuestion: [], //题目
      currentIndex: 1, //索引
      topicTypeZn: this.$route.query.topicTypeZn,
    };
  },
  mounted() {
    this.getDatas();
  },
  methods: {
    /**
     * 获取查看解析
     */
    async getDatas() {
      const params = {
        make_id: this.make_id,
      };
      const res = await getAnalysis(params);
      if (res.code == 200) {
        const { info, question, questionTitleList, sum } = res.result;
        this.otherInfoDTO = info;
        this.otherInfoDTO.title = info.title ? info.title.split("|") : [];
        // console.log(2222222);
        // console.log(this.otherInfoDTO.title);
        // console.log(11111111111);
        this.topicLists = question;
        this.topicCard = questionTitleList;
        this.total = sum;
      }
    },
    /**
     * 点击答题卡到当前题
     */
    jumpTo(sort) {
      let scrollDom = document.getElementById("leftBox");
      let dom = document.querySelector("#id_" + sort);
      if (!dom) {
        return;
      }
      let top = dom.offsetTop - 200;
      scrollDom.scrollTo({
        top: top,
        behavior: "smooth",
      });
    },
    /**
     * 提交
     */
    submit() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss">
.el-radio__input.is-disabled + span.el-radio__label {
  color: #666;
}
.topicDivButton {
  background: #fff;
  margin-bottom: 20px;
}
</style>
<style lang="scss" scoped>
.uni-startPractice {
  display: flex;
  .iconfanhui {
    color: #999999;
    font-size: 38px;
    position: absolute;
    left: 20px;
    &:hover {
      color: #666666;
    }
  }
  .spanColor {
    color: #666666;
    font-size: 14px;
  }
  .leftBox {
    //background-color: #ffffff;
    height: $contentH;
    flex: 1;
    //padding: 20px 40px;
    overflow-y: scroll;
    overflow-x: hidden;
    margin: 20px 20px 0 20px;
    position: relative;
    &::-webkit-scrollbar {
      @include uni-hidden;
    }

    .grade {
      float: right;
      min-width: 142px;
      line-height: 80px;
      background: #e64040;
      color: #fff;
      font-size: 32px;
      text-align: center;
      position: absolute;
      right: 0;
      top: 0;
    }
    .title {
      display: flex;
      justify-content: center;
      align-items: center;
      background: #fff;
      height: 200px;
      span {
        font-size: 18px;
        color: #000;
        font-weight: 400;
        display: flex;
        &:first-child {
          font-size: 20px;
          font-weight: 700;
        }
        em {
          margin: 0 14px;
          display: flex;
          height: 26px;
          width: 1px;
          background: $gray;
        }
      }
    }

    .total-text {
      display: flex;
      color: $grayLight;
      margin-top: 20px;
      padding: 10px 0;
      border-bottom: 1px solid $grayLight2;
      flex-wrap: wrap;
      .totalTextSpan {
        margin-bottom: 5px;
      }
    }

    .clear {
      margin: 65px 60px 0 60px;
      height: 1px;
      border: 1px dashed #e8e8e8;
    }
    .speed {
      padding-bottom: 52px;
      border-bottom: 1px dashed #e8e8e8;
      .text {
        color: #9a9a9a;
        font-size: 14px;
        margin: 30px 0 20px 0;
      }
      .strip {
        display: flex;
        align-items: center;
        .box {
          flex: 1;
        }
        .textBox {
          margin-left: 32px;
          span {
            font-size: 14px;
            color: #9a9a9a;
            &:first-child {
              color: #f38829;
            }
          }
          em {
            font-style: normal;
            margin: 0 10px;
            color: #9a9a9a;
          }
        }
      }
    }

    .submit {
      display: flex;
      justify-content: flex-end;
      div {
        @include uni-button;
        @include bgColor("primary");
      }
    }
  }
}
.questionAskTitle {
  width: 100%;
  padding: 20px;
  background-color: #fff;
  text-indent: 2em;
  line-height: 26px;
  color: #333;
  margin-top: 48px;
  word-break: break-word;
  white-space:pre-line
}
.audioDiv {
  display: inline-block;
}
.audioDiv .sourceAudio {
  width: 300px;
  margin: 20px;
}
</style>
